import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';


export interface ComponentHasUnsavedChanges {
  hasUnsavedChanges: () => boolean | Observable<boolean>;
}

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<ComponentHasUnsavedChanges> {
  /**
   * Adapted from: https://stackoverflow.com/a/41187919/8412361
   *
   * Usage:
   *
   * # Routing
   * {
   *   path: 'collection/:id/configure',
   *   component: ConfigureItemComponent,
   *   canDeactivate: [UnsavedChangesGuard]
   * }
   *
   * # Component
   * export class MyComponent implements ComponentHasUnsavedChanges {
   *   hasUnsavedChanges() {
   *     // Return bool indicating whether unsaved changes are present
   *   }
   *   @HostListener('window:beforeunload')
   *   allowUnload() {
   *     return !this.hasUnsavedChanges();
   *   }
   * }
   *
   * The allowUnload function with HostListener is needed to protect against
   * browser close and refresh.
   */
  canDeactivate(component: ComponentHasUnsavedChanges): boolean | Observable<boolean> {
    if (component.hasUnsavedChanges()) {
      return confirm('You have unsaved changes. If you proceed those changes will be lost.');
    } else {
      return true;
    }
  }
}
